export function trackGAEvent(action, category, label) {
	window.firePowsterCustomEvent?.(action, category, label);
}